export const TOTAL_STEPS = 8

export const guideSteps = [
  { number: 1, title: 'Sign in to Stripe' },
  { number: 2, title: 'Open "Secure your account"' },
  { number: 3, title: 'Secure your account' },
  { number: 4, title: 'Connect your phone' },
  { number: 5, title: 'Save your backup codes' },
  { number: 6, title: 'Choose the free option' },
  { number: 7, title: 'Review and submit' },
  { number: 8, title: 'Add the bank account' },
]
